/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_ADDRESPONDENTANSWER,ADDRESPONDENTANSWER_RECEIVED } = constants.AddRespondentAnswerConstant;

export default {
    REQUEST_ADDRESPONDENTANSWER,
    ADDRESPONDENTANSWER_RECEIVED,

  requestRescheduleslot: payload => ({
    type: REQUEST_ADDRESPONDENTANSWER,
    payload
  }),
  RescheduleslotReceived: () => ({
    type: ADDRESPONDENTANSWER_RECEIVED
  }),
};
